import reducerCreator from './higherOrderEntityReducers/basicReducerCreator'
import { SAVE_CUSTOMER_MESSAGES } from '../../actions/actionTypes'

export default reducerCreator([
    SAVE_CUSTOMER_MESSAGES,
])
